import { useState, type FormEvent } from 'react';
import { PLAYER_NAME_MAX_LENGTH, validatePlayerName } from '@secretnenshi/shared';
import { Button, Field, Page } from '../components/ui';
import { createGame, go, showNotice } from '../state/actions';
import { useStore } from '../state/store';

export function CreateGame() {
  const busy = useStore((s) => s.busy);
  const [name, setName] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const error = validatePlayerName(name);
    if (error) return showNotice({ kind: 'error', text: error });
    void createGame(name);
  };

  return (
    <Page title="Create game" onBack={() => go({ name: 'landing' })}>
      <form className="form" onSubmit={submit}>
        <Field
          label="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={PLAYER_NAME_MAX_LENGTH}
          autoComplete="nickname"
          autoCapitalize="words"
          enterKeyHint="go"
          autoFocus
          required
        />
        <Button type="submit" disabled={busy}>
          Create game
        </Button>
      </form>
    </Page>
  );
}
